import React, { AllHTMLAttributes, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import Title from "../_CMPT/Title";
import XtSvg from "@/components/Xt/Svg";
// import withdrawIcon from "@/assets/icon-svg/account/withdrawIcon.svg";
import { Tag } from "antd";
import { waitRes } from "@/utils/axios";
import { get_fastWithdrawStatus } from "@/api/xt4/wallet";
import Link from "next/link";
interface WithdrawalSettingProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
const { useTranslation } = Hooks;
const { getUrl } = Util;
const WithdrawalSetting: React.FC<WithdrawalSettingProps> = ({ className }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const [isCurrency, setIsCurrency] = useState(false);
  // useEffect
  useEffect(() => {
    getSwitchStatus();
  }, []);

  // method
  const getSwitchStatus = async () => {
    const { data, err } = await waitRes(get_fastWithdrawStatus);
    if (!err) setIsCurrency(!!data);
  };
  return (
    <div className={cx(styles.withdrawalSetting, className)}>
      <Title title={t("withdrawal.setting")}></Title>
      <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
        <div className={styles["account_list_common_left"]}>
          {/* <div>
            <XtSvg src={withdrawIcon} style={{ width: "45px", height: "45px" }}></XtSvg>
          </div> */}
          <div className={styles["account_sign"]}>
            <div className={styles["account_sign_header"]}>
              <span className={styles["account_sign_header_tit"]}>{t("withdrawal.currency")}</span>
              {isCurrency && <Tag className="whiteList">{t("withdrawal.enabled")}</Tag>}
            </div>
            <div className={styles["account_sign_footer"]}>
              <span className={styles["account_sign_header_desc"]}>{t("withdrawal.currencyTips")}</span>
            </div>
          </div>
        </div>

        <div className={styles["account_list_common_center"]}>
          <a className={styles["account_sign_a"]} href={getUrl("/wallet/account/common/address")}>
            {!isCurrency ? (
              <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])}>{t("account.Set")}</span>
            ) : (
              <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}>{t("account.change")}</span>
            )}
          </a>
        </div>
      </div>
    </div>
  );
};
export default observer(WithdrawalSetting);
